import i18n from "i18next";
/* import Backend from "i18next-http-backend"; */
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEN from "./Translation/EnglishTranslation.json";
import translationJA from "./Translation/JapaneseTranslation.json";
import translationKO from "./Translation/KoreanTranslation.json";
import translationES from "./Translation/SpanishTranslation.json";
import translationZH from "./Translation/ChineseTranslation.json";
import translationARAB from "./Translation/ArabicTranslation.json";
import translationFR from "./Translation/FrenchTranslation.json";
import translationMA from "./Translation/MalayTranslation.json";
import translationRU from "./Translation/RussianTranslation.json";
import translationIN from "./Translation/IndonesianTranslation.json";

// the translations

i18n
  .use(LanguageDetector)
  .use(initReactI18next)

  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      ja: {
        translation: translationJA,
      },
      ko: {
        translation: translationKO,
      },
      es: {
        translation: translationES,
      },
      zh: {
        translation: translationZH,
      },
      arab: {
        translation: translationARAB,
      },
      fr: {
        translation: translationFR,
      },
      ma: {
        translation: translationMA,
      },
      ru: {
        translation: translationRU,
      },
      in: {
        translation: translationIN,
      },
    },
  });

i18n.changeLanguage("en");

export default i18n;
